// Local display fallback while the live checkout service responds.
// The server remains the source of truth for payment and available dates.
// Full online payment: first standard split-system deep clean is $200.
export const scheduledCleaningPrice = () => 200;
